// import { useNavigate } from "react-router-dom";
// import React, { useEffect, useState } from "react";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { fetchUserOrderHistory } from "../../../Redux Toolkit/Customer/OrderSlice";
// import {
//   ChevronDown,
//   ChevronLeft,
//   ChevronRight,
//   RotateCcw,
//   Filter,
//   Search,
// } from "lucide-react";
// import { formatDate } from "../../util/fomateDate";

// const ORDERS_PER_PAGE = 10;

// const Order = () => {
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();
//   const { auth, orders } = useAppSelector((store) => store);
//   const [page, setPage] = useState(1);

//   useEffect(() => {
//     dispatch(fetchUserOrderHistory(localStorage.getItem("jwt") || ""));
//   }, [auth.jwt, dispatch]);

//   const sortedOrders = (orders?.orders || []).slice().reverse();
//   const totalPages = Math.ceil(sortedOrders.length / ORDERS_PER_PAGE);

//   const paginatedOrders = sortedOrders.slice(
//     (page - 1) * ORDERS_PER_PAGE,
//     page * ORDERS_PER_PAGE
//   );

//   const getOrderImage = (order: any) => {
//     return (
//       order?.orderItems?.[0]?.product?.images?.[0] ||
//       "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?q=80&w=300&auto=format&fit=crop"
//     );
//   };

//   const getOrderAmount = (order: any) => {
//     return order.totalSellingPrice || order.totalMrpPrice || 0;
//   };

//   return (
//     <div className="min-h-screen bg-white">
//       <div className="mb-5 flex items-start justify-between">
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900">My Orders</h1>
//           <p className="mt-2 text-sm text-gray-500">
//             Track, view and manage all your orders in one place.
//           </p>
//         </div>

//         {/* <div className="flex w-full gap-4 lg:w-auto">
//           <div className="relative w-full lg:w-[380px]">
//             <input
//               type="text"
//               placeholder="Search by order ID / product..."
//               className="h-[46px] w-full rounded-lg border border-gray-200 bg-white px-4 pr-11 text-sm outline-none focus:border-primary-color"
//             />
//             <Search
//               size={19}
//               className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-800"
//             />
//           </div>

//           <button className="hidden h-[46px] items-center gap-2 rounded-lg border border-primary-color px-5 text-sm font-medium text-primary-color lg:flex">
//             <Filter size={17} />
//             Filter
//           </button>
//         </div> */}
//       </div>

//       <div className="border-t border-gray-200 pt-5">
//         <div className="mb-3 flex justify-end">

//           <div className="flex items-center gap-2">
//             <span className="hidden text-sm text-gray-700 sm:inline">
//               Sort by:
//             </span>
//             <select className="h-[40px] rounded-lg border border-gray-200 bg-white px-4 text-sm outline-none focus:border-primary-color">
//               <option>Order Date: Newest</option>
//               <option>Order Date: Oldest</option>
//             </select>
//           </div>
//         </div>

//         {paginatedOrders.length > 0 ? (
//           <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
//             {paginatedOrders.map((order) => {
//               const firstItem = order.orderItems?.[0];
//               const status = order.orderStatus || "Placed";

//               return (
//                 <div
//                   key={order.id}
//                   className="grid grid-cols-1 items-center gap-4 border-b border-gray-200 px-4 py-5 last:border-b-0 md:grid-cols-[90px_minmax(300px,2fr)_1fr_1fr_180px_24px]"
//                 >
//                   <div className="h-[88px] w-[88px] overflow-hidden rounded-lg bg-gray-100">
//                     {order.orderItems?.length > 1 ? (
//                       <div
//                         className={`grid h-full w-full gap-[2px] bg-white p-[2px] ${order.orderItems.length === 2
//                             ? "grid-cols-2"
//                             : order.orderItems.length === 3
//                               ? "grid-cols-2 grid-rows-2"
//                               : "grid-cols-2 grid-rows-2"
//                           }`}
//                       >
//                         {order.orderItems.slice(0, 4).map((item, index) => {
//                           const isThreeItems =
//                             order.orderItems.length === 3 && index === 0;

//                           return (
//                             <div
//                               key={item.id}
//                               className={`overflow-hidden bg-gray-100 ${isThreeItems ? "row-span-2" : ""
//                                 }`}
//                             >
//                               <img
//                                 src={
//                                   item.product?.images?.[0] ||
//                                   "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?q=80&w=300&auto=format&fit=crop"
//                                 }
//                                 alt={item.product?.title || "Order product"}
//                                 className="h-full w-full object-cover"
//                               />
//                             </div>
//                           );
//                         })}
//                       </div>
//                     ) : (
//                       <img
//                         src={getOrderImage(order)}
//                         alt={firstItem?.product?.title || "Order product"}
//                         className="h-full w-full object-cover"
//                       />
//                     )}
//                   </div>

//                   <div>
//                     <h2 className="whitespace-nowrap text-base font-semibold text-gray-900">
//                       Order #OD102694500000{order.id}
//                     </h2>
//                     <p className="mt-1 text-sm text-gray-500">
//                       {order.orderItems?.length || 0} Items
//                     </p>
//                     <button className="mt-2 flex items-center gap-1 text-sm font-medium text-primary-color">
//                       <RotateCcw size={14} />
//                       Buy Again
//                     </button>
//                   </div>

//                   <div className="flex flex-col gap-2">
//                     <span className="inline-flex w-fit items-center gap-1 rounded-md bg-green-50 px-3 py-1 text-xs font-semibold text-green-700">
//                       <span className="h-2 w-2 rounded-full bg-green-600" />
//                       {status}
//                     </span>

//                     <div className="text-sm text-gray-500">
//                       <p>
//                         {order.orderDate
//                           ? formatDate(order.orderDate)
//                           : "28 May 2024"}
//                       </p>
//                     </div>
//                   </div>

//                   <div>
//                     <p className="font-semibold text-gray-900">
//                       ₹{getOrderAmount(order)}
//                     </p>
//                     <p className="mt-1 text-sm text-gray-500">Online Payment</p>
//                   </div>

//                   <button
//                     onClick={() =>
//                       navigate(`/account/orders/${order.id}/${firstItem?.id}`)
//                     }
//                     className="h-[38px] rounded-md border border-primary-color px-5 text-sm font-semibold text-primary-color transition hover:bg-transparent active:bg-transparent">
//                     View Details
//                   </button>

//                   <ChevronDown size={18} className="hidden text-gray-800 md:block" />
//                 </div>
//               );
//             })}
//           </div>
//         ) : (
//           <div className="rounded-xl border border-gray-200 bg-white p-8 text-center">
//             <h2 className="text-lg font-semibold text-gray-900">
//               No orders found
//             </h2>
//             <p className="mt-1 text-sm text-gray-500">
//               Your orders will appear here once you place them.
//             </p>
//           </div>
//         )}
//       </div>

//       {totalPages > 1 && (
//         <div className="mt-6 flex flex-col items-center gap-4">
//           <p className="text-sm text-gray-600">
//             Showing {(page - 1) * ORDERS_PER_PAGE + 1} to{" "}
//             {Math.min(page * ORDERS_PER_PAGE, sortedOrders.length)} of{" "}
//             {sortedOrders.length} orders
//           </p>

//           <div className="flex items-center gap-2">
//             <button
//               onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
//               disabled={page === 1}
//               className="flex h-9 w-9 items-center justify-center rounded-md border border-gray-200 bg-white disabled:opacity-50"
//             >
//               <ChevronLeft size={16} />
//             </button>

//             {Array.from({ length: totalPages }, (_, index) => index + 1)
//               .filter((pageNumber) => {
//                 return (
//                   pageNumber <= 3 ||
//                   pageNumber > totalPages - 2 ||
//                   Math.abs(pageNumber - page) <= 1
//                 );
//               })
//               .map((pageNumber, index, visiblePages) => {
//                 const previousPage = visiblePages[index - 1];
//                 const showDots = previousPage && pageNumber - previousPage > 1;

//                 return (
//                   <React.Fragment key={pageNumber}>
//                     {showDots && <span className="px-1 text-gray-400">...</span>}

//                     <button
//                       onClick={() => setPage(pageNumber)}
//                       className={`h-9 min-w-[36px] rounded-md border px-3 text-sm font-medium transition ${page === pageNumber
//                         ? "border-primary-color bg-white text-primary-color"
//                         : "border-gray-200 bg-white text-gray-700 hover:bg-white hover:border-primary-color"
//                         }`}
//                     >
//                       {pageNumber}
//                     </button>
//                   </React.Fragment>
//                 );
//               })}

//             <span className="px-1 text-gray-400">...</span>

//             <button className="h-9 min-w-[36px] rounded-md border border-gray-200 bg-white px-3 text-sm">
//               {totalPages}
//             </button>

//             <button
//               onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
//               disabled={page === totalPages}
//               className="flex h-9 w-9 items-center justify-center rounded-md border border-gray-200 bg-white disabled:opacity-50"
//             >
//               <ChevronRight size={16} />
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Order;


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import { fetchUserOrderHistory } from "../../../Redux Toolkit/Customer/OrderSlice";
import {
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  RotateCcw,
} from "lucide-react";
import { formatDate } from "../../util/fomateDate";

const ORDERS_PER_PAGE = 10;

const Order = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { auth, orders } = useAppSelector((store) => store);
  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch(fetchUserOrderHistory(localStorage.getItem("jwt") || ""));
  }, [auth.jwt, dispatch]);

  const sortedOrders = (orders?.orders || []).slice().reverse();
  const totalPages = Math.ceil(sortedOrders.length / ORDERS_PER_PAGE);

  const paginatedOrders = sortedOrders.slice(
    (page - 1) * ORDERS_PER_PAGE,
    page * ORDERS_PER_PAGE
  );

  const getOrderImage = (order: any) =>
    order?.orderItems?.[0]?.product?.images?.[0] ||
    "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?q=80&w=300&auto=format&fit=crop";

  const getOrderAmount = (order: any) =>
    order.totalSellingPrice || order.totalMrpPrice || 0;

  return (
    <div className="min-h-screen bg-white">
      <div className="mb-6 flex flex-col gap-4 border-b border-gray-200 pb-5 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">My Orders</h1>
          <p className="mt-2 text-sm text-gray-500">
            Track, view and manage all your orders in one place.
          </p>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-700">Sort by:</span>
          <select className="h-[42px] rounded-lg border border-gray-200 bg-white px-4 text-sm outline-none focus:border-primary-color">
            <option>Order Date: Newest</option>
            <option>Order Date: Oldest</option>
          </select>
        </div>
      </div>

      {paginatedOrders.length > 0 ? (
        <div className="space-y-2 md:space-y-0 md:overflow-hidden md:rounded-xl md:border md:border-gray-200 md:bg-white">
          {paginatedOrders.map((order) => {
            const firstItem = order.orderItems?.[0];
            const status = order.orderStatus || "Placed";

            return (
              <div
                key={order.id}
                className="grid grid-cols-[96px_1fr_auto] gap-3 rounded-xl border border-gray-200 p-4 md:grid-cols-[110px_minmax(340px,2fr)_1fr_1fr_190px] md:items-center md:rounded-none md:border-0 md:border-b md:px-4 md:py-5 md:last:border-b-0"
              >
                <div className="row-span-3 h-[88px] w-[88px] overflow-hidden rounded-lg bg-gray-100 md:row-span-1">
                  {order.orderItems?.length > 1 ? (
                    <div
                      className={`grid h-full w-full gap-[2px] bg-white p-[2px] ${order.orderItems.length === 2
                        ? "grid-cols-2"
                        : "grid-cols-2 grid-rows-2"
                        }`}
                    >
                      {order.orderItems.slice(0, 4).map((item, index) => {
                        const isThreeItems =
                          order.orderItems.length === 3 && index === 0;

                        return (
                          <div
                            key={item.id}
                            className={`overflow-hidden bg-gray-100 ${isThreeItems ? "row-span-2" : ""
                              }`}
                          >
                            <img
                              src={
                                item.product?.images?.[0] ||
                                "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?q=80&w=300&auto=format&fit=crop"
                              }
                              alt={item.product?.title || "Order product"}
                              className="h-full w-full object-cover"
                            />
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <img
                      src={getOrderImage(order)}
                      alt={firstItem?.product?.title || "Order product"}
                      className="h-full w-full object-cover"
                    />
                  )}
                </div>

                <div>
                  <h2 className="text-base font-semibold text-gray-900 sm:whitespace-nowrap">
                    Order #OD102694500000{order.id}
                  </h2>
                  <p className="mt-1 text-sm text-gray-500">
                    {order.orderItems?.length || 0} Items
                  </p>
                  <button className="mt-2 flex items-center gap-1 text-sm font-medium text-primary-color hover:bg-transparent active:bg-transparent">
                    <RotateCcw size={14} />
                    Buy Again
                  </button>
                </div>

                <div className="col-start-2 flex flex-col gap-2 md:col-start-auto">
                  <span
                    className={`inline-flex w-fit items-center gap-1 rounded-md px-3 py-1 text-xs font-semibold ${status.toLowerCase() === "delivered"
                      ? "bg-green-50 text-green-700"
                      : status.toLowerCase() === "cancelled" ||
                        status.toLowerCase() === "canceled"
                        ? "bg-red-50 text-red-700"
                        : status.toLowerCase() === "pending"
                          ? "bg-yellow-50 text-yellow-700"
                          : "bg-blue-50 text-blue-700"
                      }`}
                  >
                    <span
                      className={`h-2 w-2 rounded-full ${status.toLowerCase() === "delivered"
                        ? "bg-green-600"
                        : status.toLowerCase() === "cancelled" ||
                          status.toLowerCase() === "canceled"
                          ? "bg-red-600"
                          : status.toLowerCase() === "pending"
                            ? "bg-yellow-500"
                            : "bg-blue-600"
                        }`}
                    />
                    {status}
                  </span>
                  {/* <span className="inline-flex w-fit items-center gap-1 rounded-md bg-green-50 px-3 py-1 text-xs font-semibold text-green-700">
                    <span className="h-2 w-2 rounded-full bg-green-600" />
                    {status}
                  </span> */}
                  <p className="text-sm text-gray-500">
                    {order.orderDate ? formatDate(order.orderDate) : "28 May 2024"}
                  </p>
                </div>

                <div className="col-start-3 row-start-1 text-right md:col-start-auto md:row-start-auto md:text-left">
                  <p className="font-semibold text-gray-900">
                    ₹{getOrderAmount(order)}
                  </p>
                  <p className="mt-1 text-sm text-gray-500">Online Payment</p>
                </div>

                <button
                  onClick={() =>
                    navigate(`/account/orders/${order.id}/${firstItem?.id}`)
                  }
                  className="mt-2 h-[42px] w-full rounded-md border border-primary-color bg-white px-5 text-sm font-semibold text-primary-color hover:bg-white active:bg-white md:mt-0 md:h-[38px] md:w-auto"
                >
                  View Details
                </button>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="rounded-xl border border-gray-200 bg-white p-8 text-center">
          <h2 className="text-lg font-semibold text-gray-900">No orders found</h2>
          <p className="mt-1 text-sm text-gray-500">
            Your orders will appear here once you place them.
          </p>
        </div>
      )}

      {totalPages > 1 && (
        <div className="mt-6 flex flex-col items-center gap-4">
          <p className="text-sm text-gray-600">
            Showing {(page - 1) * ORDERS_PER_PAGE + 1} to{" "}
            {Math.min(page * ORDERS_PER_PAGE, sortedOrders.length)} of{" "}
            {sortedOrders.length} orders
          </p>

          <div className="flex items-center justify-center gap-2">
            <button
              onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
              disabled={page === 1}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-gray-200 bg-white hover:bg-white disabled:opacity-50"
            >
              <ChevronLeft size={16} />
            </button>

            {Array.from({ length: totalPages }, (_, index) => index + 1)
              .filter(
                (pageNumber) =>
                  pageNumber <= 3 ||
                  pageNumber > totalPages - 2 ||
                  Math.abs(pageNumber - page) <= 1
              )
              .map((pageNumber, index, visiblePages) => {
                const previousPage = visiblePages[index - 1];
                const showDots = previousPage && pageNumber - previousPage > 1;

                return (
                  <React.Fragment key={pageNumber}>
                    {showDots && <span className="px-1 text-gray-400">...</span>}

                    <button
                      onClick={() => setPage(pageNumber)}
                      className={`h-9 min-w-[36px] rounded-md border bg-white px-3 text-sm font-medium hover:bg-white ${page === pageNumber
                        ? "border-primary-color text-primary-color"
                        : "border-gray-200 text-gray-700"
                        }`}
                    >
                      {pageNumber}
                    </button>
                  </React.Fragment>
                );
              })}

            <button
              onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={page === totalPages}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-gray-200 bg-white hover:bg-white disabled:opacity-50"
            >
              <ChevronRight size={16} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Order;